import { Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function LoyaltySideNav() {
  const { activeSideNavID } = useSelector((state) => state.loyaltySideNav);

  return (
    <Menu fluid vertical>
      <Menu.Item>
        <Menu.Header>My Loyalty Management</Menu.Header>
        <Menu.Menu>
          <Menu.Item
            name="View Redeemable Serials"
            active={activeSideNavID === "viewRedeemableSerial"}
            as={Link}
            to="/loyalty"
          />
          <Menu.Item
            name="View Claimed History"
            active={activeSideNavID === "claimedHistory"}
            as={Link}
            to="/loyalty/claimed-history"
          />
        </Menu.Menu>
      </Menu.Item>
    </Menu>
  );
}

export default LoyaltySideNav;
